import { useMemo } from "react";
import { IPagePermission } from "../models/RoleWisePages";
import { ILogin } from "../models/Login";

interface IPageFeature extends IPagePermission {
    features: IPagePermission[];
}

const useAuth = (): {
    loginObj: ILogin | null;
    pageFeatures: IPageFeature[],
    hasPermission: (pageName: string, featureName?: string) => boolean
} => {

    const auth: string = sessionStorage.getItem("auth") ?? "";
    const loginObj: ILogin | null = auth ? JSON.parse(auth) : null;

    const pageFeatures = useMemo(() => {
        if (!loginObj) return [];

        const features: IPageFeature[] = [];

        const parentPages = loginObj.permissions.filter(p => !p.isFeature);

        parentPages.forEach(pp => {
            const pageFeature: IPageFeature = {
                ...pp,
                features: []
            };

            loginObj.permissions.forEach(p => {
                if (pp.pageId === p.parentId) {
                    pageFeature.features.push(p);
                }
            });

            features.push(pageFeature);
        });

        return features;
    }, [auth]);

    const hasPermission = (pageName: string, featureName?: string): boolean => {
        const page = pageFeatures.find(page => page.name === pageName);
        if (!page) return false;
        if (!featureName) {
            return page.permission;
        }
        return page.features.some(f => f.name === featureName && f.permission);
    };

    return { loginObj, pageFeatures, hasPermission };
};

export default useAuth;
